<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style">
    <form [formGroup]="formInvoiceInfo">
      <div class="col-lg-12 me-1 me-lg-0">
        <div class="row mt-1">
          <div class="col-md-2 col-4">
            <app-custom-tag [label]="''" [value]="bussinessDocumentsTypeIsRental"></app-custom-tag>
          </div>
          <div class="col-lg-4">
            <app-custom-input-text [labelText]="'Tipo DIAN'" [value]="codeNameTypeDIAN!"
              [disabled]="true"></app-custom-input-text>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-3 col-6 d-flex justify-content-center align-items-end">
            <app-custom-chip [label]="'Fra.Cop: ' + (invoiceOriginConsecutive ?? '')" />
          </div>
          <div class="col-lg-2 col-md-3 col-sm-3 col-6 d-flex justify-content-center align-items-end">
            <app-custom-chip [label]="'Interfaz: ' + accountingInterfaceCode" />
          </div>
          <div class="col-lg-2 col-md-3 col-sm-3 col-6 d-flex justify-content-center align-items-end">
            <app-custom-chip [label]="'Movto: ' + movementCode" />
          </div>
          <div class="custom-container col-lg-6 col-md-6 col-sm-6  mt-2">
            <app-custom-select class="custom-field" formControlName="invoiceOperationId" [labelText]="'Operación'"
              [required]="true" [list]="listInvoiceOperations"
              (onChangeSelect)="changeOperation($event)"></app-custom-select>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-6 mt-2 pb-1 d-flex justify-content-center align-items-end">
            <app-custom-checkbox formControlName="swCopied" [labelText]="'Fra.Copiada'"></app-custom-checkbox>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-6 mt-2 pb-1 d-flex justify-content-center  align-items-end">
            <app-custom-checkbox formControlName="swManual" [labelText]="'Fra. Manual'"></app-custom-checkbox>
          </div>
          <div class="custom-container col-lg-6 col-sm-6 mt-2">
            <app-custom-autocomplete class="custom-field" formControlName="zoneId" [labelText]="'Zona'"
              [required]="true" [list]="listZones" (onChangeSelect)="getZone($event)"></app-custom-autocomplete>
          </div>
          <div class="custom-container col-lg-6 col-sm-6 mt-2">
            <app-custom-autocomplete class="custom-field" formControlName="sellerId" [labelText]="'Vendedor'"
              [required]="true" [list]="listSellers"></app-custom-autocomplete>
          </div>
          <div class="custom-container col-lg-6 col-sm-6 mt-2">
            <app-custom-select class="custom-field" formControlName="conceptPaymentMethodId" [required]="true"
              [labelText]="'Medio de pago'" [list]="listPaymentMethods"></app-custom-select>
          </div>
          <div class="custom-container mt-2"
            [ngClass]="enableSetInvoiceWalletType ? 'col-lg-5 col-sm-6' : 'col-lg-6 col-sm-6'">
            <app-custom-select class="custom-field" formControlName="invoiceWalletTypeId" [labelText]="'Tipo Cartera'"
              [required]="true" [list]="listInvoiceWalletTypes"></app-custom-select>
          </div>
          <div *ngIf="enableSetInvoiceWalletType" class="col-lg-1 col-md-1 col-sm-1 col-2 d-flex align-items-end">
            <app-custom-button [title]="'Cambiar Tipo Cartera'" [label]="''" (onClick)="setInvoiceWalletType()"
              [severity]="'success'" [icon]="'pi pi-sync'"></app-custom-button>
          </div>
          <div class="col-lg-12 col-12 mt-2">
            <app-custom-input-text [labelText]="'CUFE'" [value]="cufe!" [disabled]="true"></app-custom-input-text>
          </div>
          <div class="col-lg-12 col-12 mt-2 d-flex justify-content-end gap-2">
            <app-custom-button [title]="'Salir'" [label]="'Salir'" [variant]="undefined" [severity]="'danger'"
              (onClick)="close()"></app-custom-button>
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              [disabled]="!permissionUpdatable || invoiceModel.invoiceStateId != invoiceStateOpen"
              (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>